import type { FooterTemplate } from '@iheartjane/data-access';
import { Card, Flex, Typography } from '@iheartjane/reefer';
import { Controller, useFormContext } from 'react-hook-form';

import { QuillEditor } from '@jane/business-admin/components/richEditor/QuillEditor';

import styles from './Footer.module.css';

export const TextAreaSection = () => {
  const { control } = useFormContext<FooterTemplate>();

  return (
    <Card
      border="grays-ultralight"
      className={styles['sectionCard']}
      id="text_content"
    >
      <Flex flexDirection="column" gap={16} p={40}>
        <Typography variant="h2-semibold">Text area</Typography>
        <Typography>
          Use this area to add any large body of text. It will appear at the
          bottom of your footer.
        </Typography>

        <Controller
          name="text_content"
          control={control}
          render={({ field }) => (
            <QuillEditor
              {...field}
              value={field.value ?? ''}
              onChange={field.onChange}
            />
          )}
        />
      </Flex>
    </Card>
  );
};
